import { sectionConstants } from "../constants/sections"
import { courseConstants } from "../constants/courses"

const initialState = {
  sections: [],
  nodes: [],
  getSectionFailure: false,
  fetchingSection: false,
  sectionStatus: false,
  fetchingSectionLessons: false,
  lessons: [],
  parentCourse: {},
  parentSubcourse: {}
}

export function sectionsReducer(state = initialState, action) {
  switch (action.type) {
    case sectionConstants.ADD_SECTION_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        fetchingSection: false,
        sectionFetchError: action.error
      }
    case sectionConstants.ADD_SECTION_REQUEST:
      return {
        ...state,
        fetchingSection: true
      }

    case sectionConstants.ADD_SECTION_SUCCESS:
      return {
        ...state,
        fetchingSection: false,
        sectionData: { ...state.sectionData, ...action.change },
        newSectionCreated: true
      }
    case sectionConstants.GET_SECTION_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        fetchingSection: false,
        sectionFetchError: action.error
      }
    case sectionConstants.GET_SECTION_REQUEST:
      return {
        ...state,
        fetchingSection: true,
        sectionDeleted: false
      }

    case sectionConstants.GET_SECTION_SUCCESS:
      return {
        ...state,
        fetchingSection: false,
        sectionData: action.payload.section,
        parentSubcourse: action.payload.subcourse,
        parentCourse: action.payload.course
      }
    case sectionConstants.GET_SECTION_SUBCOURSES_FAILURE:
      return {
        ...state,
        getSubcoursesFailure: true,
        fetchingSubcourses: false,
        subcoursesFetchError: action.error
      }
    case sectionConstants.GET_SECTION_SUBCOURSES_REQUEST:
      return {
        ...state,
        fetchingSubcourses: true
      }

    case sectionConstants.GET_SECTION_SUBCOURSES_SUCCESS:
      return {
        ...state,
        fetchingSubcourses: false,
        subcourses: action.subcourses
      }

    case sectionConstants.CHANGE_SECTION_DISPLAY_NAME_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        changingDisplayName: false,
        sectionFetchError: action.error
      }
    case sectionConstants.CHANGE_SECTION_DISPLAY_NAME_REQUEST:
      return {
        ...state,
        changingDisplayName: true
      }

    case sectionConstants.CHANGE_SECTION_DISPLAY_NAME_SUCCESS:
      return {
        ...state,
        changingDisplayName: false,
        sectionData: { ...state.sectionData, ...action.change }
      }

    case sectionConstants.CHANGE_SECTION_NAME_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        changeSectionName: false,
        sectionFetchError: action.error
      }
    case sectionConstants.CHANGE_SECTION_NAME_REQUEST:
      return {
        ...state,
        changeSectionName: true
      }

    case sectionConstants.CHANGE_SECTION_NAME_SUCCESS:
      return {
        ...state,
        changeSectionName: false,
        sectionData: { ...state.sectionData, ...action.change }
      }

    case sectionConstants.CHANGE_SECTION_STARS_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        sectionFetchError: action.error
      }
    case sectionConstants.CHANGE_SECTION_STARS_REQUEST:
      return {
        ...state
      }

    case sectionConstants.CHANGE_SECTION_STARS_SUCCESS:
      return {
        ...state,
        sectionData: { ...state.sectionData, ...action.change }
      }

    case sectionConstants.TOGGLE_SECTION_STATUS_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        toggleSectionStatus: false,
        sectionFetchError: action.error
      }
    case sectionConstants.TOGGLE_SECTION_STATUS_REQUEST:
      return {
        ...state,
        toggleSectionStatus: true
      }

    case sectionConstants.TOGGLE_SECTION_STATUS_SUCCESS:
      return {
        ...state,
        toggleSectionStatus: false,
        sectionData: { ...state.sectionData, ...action.change }
      }
    case sectionConstants.CHANGE_SECTION_PARENT_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        changeSectionParent: false,
        sectionFetchError: action.error
      }
    case sectionConstants.CHANGE_SECTION_PARENT_REQUEST:
      return {
        ...state,
        changeSectionParent: true
      }

    case sectionConstants.CHANGE_SECTION_PARENT_SUCCESS:
      let parentSub = state.parentSubcourse
      if (state.subcourses) {
        parentSub = state.subcourses.filter(
          subcourse => subcourse.id === action.change.subcourseId
        )[0]
      }
      return {
        ...state,
        changeSectionParent: false,
        sectionData: { ...state.sectionData, ...action.change },
        parentSubcourse: parentSub
      }

    case sectionConstants.DELETE_SECTION_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        fetchingSection: false,
        sectionFetchError: action.error
      }
    case sectionConstants.CHANGE_SECTION_NODE_REQUEST:
      return {
        ...state,
        changeSectionNode: true
      }

    case sectionConstants.CHANGE_SECTION_NODE_SUCCESS:
      return {
        ...state,
        changeSectionNode: false,
        sectionData: { ...state.sectionData, ...action.change }
      }

    case sectionConstants.DELETE_NODE_FAILURE:
      return {
        ...state,
        getSectionFailure: true,
        fetchingSection: false,
        sectionFetchError: action.error
      }
    case sectionConstants.DELETE_SECTION_REQUEST:
      return {
        ...state,
        fetchingSection: true
      }

    case sectionConstants.DELETE_SECTION_SUCCESS:
      return {
        ...state,
        fetchingSection: false,
        subcourseId: action.section.subcourseId,
        sectionDeleted: true
      }
    case courseConstants.CREATE_LESSON_SUCCESS:
      state.sectionData &&
        (state.sectionData.lessons = action.lesson.section.lessons)
      return {
        ...state
      }

    default:
      return state
  }
}
